/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EventViewDialog from './EventViewDialog';
import {viewDeviceEvent} from './state';
import {
  adminDevicesViewEventIsEditingSelector,
  adminDevicesViewEventSelectedSelector
} from './state-selectors';

interface ViewDeviceEventDialogProp {
  enabled?: boolean;
}

/**
 * Re-usable component for displaying the view device telemetry event details dialog.
 */
export const ViewDeviceEventDialog = ({enabled}: ViewDeviceEventDialogProp) => {
  const dispatch        = useDispatch();
  const showEventDialog = useSelector(adminDevicesViewEventIsEditingSelector);
  const selectedEvent   = useSelector(adminDevicesViewEventSelectedSelector);
  
  const onViewEventClose = useCallback(() => {
    dispatch(viewDeviceEvent(null, false));
  }, []);

  if (enabled && showEventDialog && selectedEvent) {
    return (
      <EventViewDialog selectedEvent={selectedEvent}
        onCloseDialog={onViewEventClose} />
    );
  }
};

export default memo(ViewDeviceEventDialog);
